<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Transfer Record</a>
            </div>
        </div>
        <div class="box-body">
            <div class="transfer-record-view">
              <div class="transfer-record-view-top clearfix">
                <div class="from-left">
                  <label class="from">From：</label>
                  <el-date-picker type="date" placeholder="选择日期" v-model="startTime" style="width:150px;"></el-date-picker>
                  <label class="to">To</label>
                  <el-date-picker type="date" placeholder="选择时间" v-model="endTime" style="width:150px;"></el-date-picker>
                </div>
                <div class="btn-right">
                  <el-button type="primary" class="box-btn" style="width: 100px;" @click="record">SEARCH</el-button>
                </div>
              </div>
              <div class="table-view">
                  <table width="90%" class="ac-table" v-if="dataList.length!==0">
                    <thead>
                        <tr>
                            <th>
                                TIME
                            </th>
                            <th>
                                ORDER NUMBER
                            </th>
                            <th>
                                FROM
                            </th>
                            <th>
                                AMOUNT
                            </th>
                            <th>
                                TO
                            </th>
                            <th>
                                AMOUNT
                            </th>
                        </tr>
                    </thead>
                    <tr v-for="item in dataList">
                        <td>
                            {{item.apply_time}}
                        </td>
                        <td>
                            {{item.order_id}}
                        </td>
                        <td>
                            {{item.from_mt4_id}}
                        </td>
                        <td>
                            {{item.out_money}}
                        </td>
                        <td>
                            {{item.to_mt4_id}}
                        </td>
                        <td>
                            {{item.in_money}}
                        </td>
                    </tr>
                </table>
                <div class="table-null" v-else>
                    <p>no data</p>
                </div>

                <div class="box-page transfer-record-page">
                  <el-pagination
                    background
                     @current-change="handleCurrentChange"
                     :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="totalCount">
                  </el-pagination>
                </div>

              </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as server from './action'

var date = new Date()
function getLastDay(year, month) {
  var new_year = year
  var new_month = month++
  if (month > 12) {
    new_month -= 12
    new_year++
  }
  var new_date = new Date(new_year, new_month, 1)
  return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate()
}

export default {
  data() {
    return {
      startTime: `${date.getFullYear()}-${date.getMonth() + 1}-01`,
      endTime: `${date.getFullYear()}-${date.getMonth() + 1}-${getLastDay(
        date.getFullYear(),
        date.getMonth() + 1
      )}`,
      totalCount: 0,
      pageSize: 10,
      page: 1,
      dataList: []
    }
  },
  created() {
    this.record()
  },
  methods: {
    record() {
      const { startTime, endTime, pageSize, page } = this
      let params = {
        startTime,
        endTime,
        pageSize,
        page
      }
      server
        .get_transfer_record(params)
        .then(res => {
          this.dataList = res.dataList
          this.totalCount = Number(res.totalCount)
        })
        .catch(err => {})
    },
    handleCurrentChange(val) {
      this.page = val
      this.record()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.transfer-record-view {
  .transfer-record-view-top {
    margin-top: 20px;
    .from-left {
      float: left;
      .to {
        padding: 0 10px;
      }
    }
    .btn-right {
      padding-left: 15px;
      float: left;
    }
  }
  .table-view {
    margin-top: 30px;
  }
  .transfer-record-page {
    margin-top: 50px;
    text-align: center;
  }
}
</style>
